<template>
  <div>
    <b-button
      :disabled="isPDFDisabled"
      id="btn_search"
      variant="primary"
      class="btn btn-label btn-primary float-right"
      @click="pdfgen"
      ><i class="bx bxs-file-pdf label-icon"></i>Download PDF</b-button
    >
  </div>
</template>

<script>
import Vue from 'vue';
import { logo } from '../../assets/images/kaliLogo.js';
import VueToast from 'vue-toast-notification';
import 'vue-toast-notification/dist/theme-sugar.css';
Vue.use(VueToast);

export default {
  name: 'ReportsPDF',
  components: {},
  props: {
    tableData: Array,
    reportTotals: Array,
    productTableData: Array,
    productReportTotals: Array,
    summaryReport: Array,
    searchCustomer: String,
    searchJobNum: Number,
    searchStartDate: Date,
    searchEndDate: Date,
    searchEmployee: Object,
    showProducts: Boolean,
  },
  data() {
    return {
      isPDFDisabled: true,
    };
  },
  methods: {
    pdfgen: function() {
      try {
        this.isPDFDisabled = true;
        var pdfMake = require('pdfmake/build/pdfmake.js');
        var pdfFonts = require('pdfmake/build/vfs_fonts.js');
        pdfMake.vfs = pdfFonts.pdfMake.vfs;

        var docDefinition = {
          content: [
            {
              table: {
                widths: ['*', 'auto'],
                body: [
                  [
                    {
                      text: this.getHeader(),
                      style: 'header',
                      border: [false, false, false, true],
                    },
                    {
                      image: logo,
                      style: 'logo',
                      fit: [100, 100],
                      border: [false, false, false, true],
                    },
                  ],
                ],
              },
            },
            '\n\n',
            {
              columns: [
                { width: '*', text: 'Customer', style: 'subheader' },
                { width: '*', text: 'Job #', style: 'subheader' },
                { width: '*', text: 'Start Date', style: 'subheader' },
                { width: '*', text: 'End Date', style: 'subheader' },
              ],
            },
            '\n',
            {
              columns: [
                { width: '*', text: this.searchCustomer, style: 'subheader2' },
                { width: '*', text: this.searchJobNum, style: 'subheader2' },
                { width: '*', text: this.startDate, style: 'subheader2' },
                { width: '*', text: this.endDate, style: 'subheader2' },
              ],
            },
            '\n\n',
            this.getEmployee(),
            '\n',
            {
              columns: [
                { width: '*', text: 'Hours Worked', style: 'subheader' },
                { width: '*', text: 'Days Worked', style: 'subheader' },
                { width: '*', text: 'Avg. Hours/Day', style: 'subheader' },
              ],
            },
            '\n',
            {
              columns: [
                {
                  width: '*',
                  text: this.reportTotals[0].value,
                  style: 'subheader2',
                },
                {
                  width: '*',
                  text: this.reportTotals[1].value,
                  style: 'subheader2',
                },
                {
                  width: '*',
                  text: this.reportTotals[2].value,
                  style: 'subheader2',
                },
              ],
            },
            '\n',
            this.showProducts
              ? {
                  columns: [
                    {
                      width: '*',
                      text: 'Amount of Products Sold',
                      style: 'subheader',
                    },
                    {
                      width: '*',
                      text: 'Amount of Days Products Sold',
                      style: 'subheader',
                    },
                    {
                      width: '*',
                      text: 'Avg. Products/Day',
                      style: 'subheader',
                    },
                  ],
                }
              : '',
            '\n',
            this.showProducts
              ? {
                  columns: [
                    {
                      width: '*',
                      text: this.productReportTotals[0].value,
                      style: 'subheader2',
                    },
                    {
                      width: '*',
                      text: this.productReportTotals[1].value,
                      style: 'subheader2',
                    },
                    {
                      width: '*',
                      text: this.productReportTotals[2].value,
                      style: 'subheader2',
                    },
                  ],
                }
              : '',
            '\n',
            {
              columns: [
                {
                  width: '*',
                  text: '',
                },
                {
                  width: 'auto',
                  table: {
                    headerRows: 1,
                    body: this.buildTable(),
                    style: 'table',
                  },
                },
                {
                  width: '*',
                  text: '',
                },
              ],
            },
            '\n',
            this.showProducts
              ? {
                  columns: [
                    {
                      width: '*',
                      text: '',
                    },
                    {
                      width: 'auto',
                      table: {
                        headerRows: 1,
                        body: this.buildProductsTable(),
                        style: 'table',
                      },
                    },
                    {
                      width: '*',
                      text: '',
                    },
                  ],
                }
              : '',
            '\n',
            this.summaryReport
              ? {
                  columns: [
                    {
                      width: '*',
                      text: '',
                    },
                    {
                      width: 'auto',
                      table: {
                        headerRows: 1,
                        body: this.buildSummaryTable(),
                        style: 'table',
                      },
                    },
                    {
                      width: '*',
                      text: '',
                    },
                  ],
                }
              : null,
          ],
          styles: {
            header: {
              fontSize: 25,
              bold: true,
              alignment: 'left',
            },
            subheader: {
              fontSize: 18,
              bold: true,
              alignment: 'center',
              color: '#556ee6',
            },
            subheader2: {
              fontSize: 13,
              bold: true,
              alignment: 'center',
            },
            employeeName: {
              fontSize: 22,
              bold: true,
              alignment: 'center',
              decoration: 'underline',
            },
            table: {
              width: '*',
            },

            logo: { alignment: 'center' },
          },
        };
        let pdfFileTitle = this.searchEmployee
          ? `${this.searchEmployee.displayName.split('.').join('')} Employee Hours Report`
          : `Hours Worked Report`;

        pdfMake.createPdf(docDefinition).download(pdfFileTitle);
        this.isPDFDisabled = false;
      } catch (err) {
        Vue.$toast.open({
          message: `Error generating report (generation): ${err}.`,
          type: 'error',
          duration: 4000,
          position: 'top-right',
        });
      }
    },
    buildTable: function() {
      try {
        if (this.searchEmployee) {
          let body = [['Date', 'Customer', 'Job', 'Description', 'Hours']];
          this.tableData.forEach((item) => {
            body.push([
              item.Date ? item.Date : null,
              item.Customer ? item.Customer : null,
              item.Job ? item.Job : null,
              item.Description ? item.Description : null,
              item.Hours ? item.Hours : null,
            ]);
          });
          return body;
        } else {
          let body = [
            [
              'Date',
              'Job #',
              'Customer',
              'Employee',
              'Description',
              'Hours',
              'Rate',
              'Line Total',
            ],
          ];

          this.tableData.forEach((item) => {
            body.push([
              item.Date ? item.Date : null,
              item.JobNum ? item.JobNum : null,
              item.Customer ? item.Customer : null,
              item.Employee ? item.Employee : null,
              item.Description ? item.Description : null,
              item.Hours ? item.Hours : null,
              item.Rate ? item.Rate : null,
              item.lineTotal ? item.lineTotal : null,
            ]);
          });

          return body;
        }
      } catch (err) {
        Vue.$toast.open({
          message: `Error generating report (times): ${err}.`,
          type: 'error',
          duration: 4000,
          position: 'top-right',
        });
      }
    },
    buildProductsTable: function() {
      try {
        if (this.searchEmployee && this.showProducts) {
          let body = [
            [
              'Date',
              'Customer',
              'Job',
              'Product',
              'Quantity',
              'Rate',
              'Line Total',
            ],
          ];
          this.productTableData.forEach((item) => {
            body.push([
              item.Date ? item.Date : null,
              item.Customer ? item.Customer : null,
              item.Job ? item.Job : null,
              item.Product ? item.Product : null,
              item.Quantity ? item.Quantity : null,
              item.Rate ? item.Rate : null,
              item.lineTotal ? item.lineTotal : null,
            ]);
          });
          return body;
        } else {
          return [];
        }
      } catch (err) {
        Vue.$toast.open({
          message: `Error generating report (products): ${err}.`,
          type: 'error',
          duration: 4000,
          position: 'top-right',
        });
      }
    },
    buildSummaryTable: function() {
      try {
        // if (!this.searchEmployee) {
        this.summaryReport.map((item) => {
          delete item.id;
          return item;
        });

        //get the keys from the syummary report, so we can dynamically generate the headers based on the passed in products.
        let body = [Object.keys(this.summaryReport[0])];

        //sort the array by employee name.
        this.summaryReport.sort((a, b) => (a.name > b.name ? 1 : -1));

        //loop the summary report and take each item and convert it to an array so it will work in the pdf table
        this.summaryReport.forEach((item) => {
          body.push(
            Object.keys(item).map((k) =>
              item[k].value !== undefined ? item[k].value : item[k]
            )
          );
        });

        return body;
      } catch (err) {
        Vue.$toast.open({
          message: `Error generating report (times): ${err}.`,
          type: 'error',
          duration: 4000,
          position: 'top-right',
        });
      }
    },
    getHeader() {
      if (this.searchEmployee) {
        return 'Employee Hours Summary Report';
      } else {
        return 'Hours Worked Summary Report';
      }
    },
    getEmployee() {
      if (this.searchEmployee) {
        return { text: this.searchEmployee.displayName, style: 'employeeName' };
      }
    },
  },
  computed: {
    startDate() {
      if (this.searchStartDate) {
        return this.searchStartDate.toString().substring(0, 15);
      } else {
        return null;
      }
    },
    endDate() {
      if (this.searchEndDate) {
        return this.searchEndDate.toString().substring(0, 15);
      } else {
        return null;
      }
    },
  },
  watch: {
    tableData: function(val) {
      if (val.length > 0) {
        this.isPDFDisabled = false;
      } else {
        this.isPDFDisabled = true;
      }
    },
    searchJobNum: function() {
      this.isPDFDisabled = true;
    },
    searchEmployee: function() {
      this.isPDFDisabled = true;
    },
    searchStartDate: function() {
      this.isPDFDisabled = true;
    },
    searchEndDate: function() {
      this.isPDFDisabled = true;
    },
    searchCustomer: function() {
      this.isPDFDisabled = true;
    },
  },
};
</script>

<style scoped></style>
